/* eslint-disable eqeqeq */
import { useEffect, useState } from 'react';
import { usePositionService, PositionType, SOFTWARE_ENGINEER_ID } from 'domain/shared/employee';
import { useTechnologyService, type Technology } from 'domain/shared/career';
import { TextField, useFieldHelper } from 'framework/ui/field';
import { Box } from '@mui/material';
import { AppIconLabel } from 'framework/ui/mui-builder';

const ProjectTeamMemberPositionField = ({
  positionIdSource,
  technologyIdSource,
  competencyLevelSource,
}: {
  positionIdSource: string;
  technologyIdSource: string;
  competencyLevelSource: string;
}) => {
  const { findAll: getAllPositions } = usePositionService();
  const { findAll: getAllTechnologies } = useTechnologyService();

  const [positions, setPositions] = useState<Nullable<PositionType[]>>(null);
  const [technologies, setTechnologies] = useState<Nullable<Technology[]>>(null);

  const { getValue: getPosition } = useFieldHelper<number>({ source: positionIdSource });
  const { getValue: getTechnology } = useFieldHelper({ source: technologyIdSource });
  const { getValue: getCompetencyLevel } = useFieldHelper({ source: competencyLevelSource });

  const position = getPosition();
  const technology = getTechnology();
  const competencyLevel = getCompetencyLevel();

  useEffect(() => {
    (async () => {
      const positionsRezult = await getAllPositions();
      const technologiessRezult = await getAllTechnologies();

      setPositions(positionsRezult);
      setTechnologies(technologiessRezult);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderValue = () => {
    const currentPosition = positions?.find(item => item.id == position);
    const currentTechnology = technologies?.find(item => item.id == technology);

    return `${competencyLevel ? `${competencyLevel}` : ''} ${currentTechnology?.name || ''} ${position == SOFTWARE_ENGINEER_ID ? 'engineer' : currentPosition?.name} `;
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      sx={{
        '& #app-icon-span-id': {
          mr: '5px !important',
        },
      }}
    >
      <AppIconLabel sxIcon={{ width: '14px' }} icon="pLetter" tooltipTitle="Company position" />
      <TextField value={renderValue()} />
    </Box>
  );
};

export default ProjectTeamMemberPositionField;
